import { PageLayout } from '@/components/PageLayout';
import { Button } from '@mui/material';
import { SentimentVeryDissatisfied as SentimentVeryDissatisfiedIcon } from '@mui/icons-material';
import { isSigningOut } from '@/config/signOutState';
import './style.scss';

// eslint-disable-next-line no-unused-vars
export function ErrorPage({ resetErrorBoundary }) {
  // A page that failed while signing out is about to be left: no "Oops!".
  if (isSigningOut()) return null;
  function handleGoToDashboard() {
    resetErrorBoundary();
    window.location.href = '/#/dashboard';
  }
  return (
    <PageLayout>
      <div className='modern-form-page modern-view-page error-page'>
        <div className='error-page-shell'>
          <SentimentVeryDissatisfiedIcon color='error' sx={{ fontSize: '7rem' }} />
          <h1 className='margin_b'>Oops!</h1>
          <h2>Something went wrong.</h2>
          <p>
            But don{"'"}t worry, our experts are already troubleshooting this error and this page
            will be back soon!
          </p>
          <Button variant='contained' color='secondary' onClick={handleGoToDashboard}>
            Go to Dashboard
          </Button>
        </div>
      </div>
    </PageLayout>
  );
}
